<template>
  <div v-if="show" class="confirm-overlay-mask">
    <div ref="dialog" tabindex="-1" class="confirm-overlay-content">
      <p class="my-3">{{ t(text) }}</p>

      <div>
        <Button class="me-3" :label="t('CANCEL')" severity="secondary" @click="handleConfirmCancel"/>
        <Button :label="t('YES')" severity="danger" @click="handleConfirmOk"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const props = defineProps({ show: Boolean, text: String });

const emit = defineEmits(["yes", "no"]);

async function handleConfirmOk() {
  emit("yes");
}

function handleConfirmCancel() {
  emit("no");
}
</script>

<style scoped>
.confirm-overlay-mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0.4);
}

.confirm-overlay-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 1rem;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 75%;
}
</style>
